<template>
    <div id="home-header" :class="{'home-header-sub-lg': ($vuetify.breakpoint.width < 1440 && $vuetify.breakpoint.width > 1264)}">
        <img class="absolute sky" width="100%" height="873px" src="@/assets/images/main/Rectangle 499.png" :class="{md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
        <img class="absolute cloud" height="296px" width="37%" src="@/assets/images/main/Vector 8.jpg" :class="{md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
        <div class="absolute logo" :class="{md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <div class="flex-center">
                <img width="80" src="@/assets/images/logo.svg">
                <div class="logo ml-6 clr-white">Tasko</div>
            </div>
            <h1 class="roboto-normal-24 clr-white mt-12 width-380" v-if="$vuetify.breakpoint.lgAndUp">Я помогу тебе создавать, структурировать и хранить заметки.</h1>
            <h1 class="roboto-normal-18 clr-white mt-12 width-380" v-else>Я помогу тебе создавать, структурировать и хранить заметки.</h1>
            <div class="absolute mt-6 pt-6" v-if="$vuetify.breakpoint.lgAndUp">
                <!-- <HomeButton/> -->
                <HomeButtonEnter/>
            </div>
            <div class="absolute mt-6" v-else>
                <!-- <HomeButton/> -->
                <HomeButtonEnter/>
            </div>
        </div>
        <div class="links absolute flex-center" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <div class="roboto-bold-24 clr-white pointer" v-if="$vuetify.breakpoint.lgAndUp">Главная</div>
            <div class="roboto-bold-18 clr-white pointer" v-if="$vuetify.breakpoint.mdOnly">Главная</div>
            <div class="roboto-bold-16 clr-white pointer" v-if="$vuetify.breakpoint.smOnly">Главная</div>
            <div class="roboto-bold-24 clr-white pointer" @click="toAboutApplication()" v-if="$vuetify.breakpoint.lgAndUp">О приложении</div>
            <div class="roboto-bold-18 clr-white pointer" @click="toAboutApplication()" v-if="$vuetify.breakpoint.mdOnly">О приложении</div>
            <div class="roboto-bold-16 clr-white pointer" @click="toAboutApplication()" v-if="$vuetify.breakpoint.smOnly">О приложении</div>
            <div class="roboto-bold-24 clr-white pointer" @click="toHowItsWork()" v-if="$vuetify.breakpoint.lgAndUp">Как это работает</div>
            <div class="roboto-bold-18 clr-white pointer" @click="toHowItsWork()" v-if="$vuetify.breakpoint.mdOnly">Как это работает</div>
            <div class="roboto-bold-16 clr-white pointer" @click="toHowItsWork()" v-if="$vuetify.breakpoint.smOnly">Как это работает</div>
        </div>
        <img class="absolute screen-app" width="38%" height="490px" src="@/assets/images/main/Group 512.png" v-if="$vuetify.breakpoint.lgAndUp">
        <img class="absolute screen-app-tablet" width="38%" height="344px" src="@/assets/images/main/Group 512 2.png" v-else>
        <img class="absolute field z-index-10" width="66%" height="490px" src="@/assets/images/main/Vector 7.png" :class="{lg:$vuetify.breakpoint.lg}" v-if="$vuetify.breakpoint.lgAndUp">
        <img class="absolute field-tablet z-index-10" width="67%" height="265px" src="@/assets/images/main/Vector 47.png" v-else>
        <img class="absolute robot" src="@/assets/images/main/Group 476.png" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
    </div>
</template>

<script>
import HomeButton from './HomeButton.vue'
import HomeButtonEnter from './HomeButtonEnter.vue'
export default {
    name: 'HomeHeader',
    data() {
        return {
            
        }
    },
    components: {
        HomeButton,
        HomeButtonEnter,
    },
    methods: {
        toAboutApplication() {
            this.$vuetify.goTo("#about-application")
        },
        toHowItsWork() {
            this.$vuetify.goTo("#how-its-work")
        },
    },
}
</script>

<style lang="scss" scoped>
$clr-black: #000000;
$clr-white: #FFFFFF;
#home-header.home-header-sub-lg {
    .logo {
        top: 297px;
    }
    .cloud {
        top: -50px;
    }
}
#home-header {
    .sky {
        &.md, &.sm {
            height:667px;
        }
    }
    .cloud {
        &.md, &.sm {
            height:157px;
            width:47%;
        }
    }
    .logo {
        top:345px;
        left:5%;
        &.md, &.sm {
            top:233px;
            left:7%;
        }
    }
    .links {
        top:79px;
        right:5%;
        width:35%;
        justify-content: space-between;
        &.lg {
            width:40%;
        }
        &.md {
            top:53px;
            width:45%;
        }
        &.sm {
            top:53px;
            width:52%;
            right:2%;
        }
    }
    .screen-app {
        top:312px;
        right:5%;
    }
    .screen-app-tablet {
        top:228px;
        right:0%;
    }
    .field {
        top:553px;
        right:0%;
    }
    .field-tablet {
        top:509px;
        right:0%;
    }
    .robot {
        top:396px;
        left:35%;
        &.lg {
            top:425px;
            left:35%;
            height:225px;
        }
        &.md {
            top:327px;
            height:161px;
            left:40%;
        }
        &.sm {
            top:407px;
            height:121px;
            left:39.5%;
        }
    }
}
</style>